import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleSignOut = () => {
    // Clear local storage
    localStorage.removeItem("adminData");
    localStorage.removeItem("customerData");
    localStorage.removeItem("staffData");
    
    // Redirect to sign-in page
    window.location.href = "/";
  }

  handleTryAgain = () => {
    // Reset the error state
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
    
    // Reload the current page
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return (
        <div className="w-full min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50">
          <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
            <div className="text-center mb-6">
              <svg className="mx-auto h-16 w-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
              </svg>
              <h2 className="text-xl font-bold text-gray-800 mt-4">Something went wrong</h2>
              <p className="text-gray-600 mt-2">
                The application encountered an unexpected error. This could be due to a session timeout or network issue.
              </p>
            </div>
            
            <div className="flex flex-col gap-3 mt-6">
              <button
                onClick={this.handleTryAgain}
                className="w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-md focus:outline-none transition-colors duration-200"
              >
                Try Again
              </button>
              <button
                onClick={this.handleSignOut}
                className="w-full py-2 px-4 bg-[#66c18a] hover:bg-[#59b37d] text-white font-medium rounded-md focus:outline-none transition-colors duration-200"
              >
                Sign Out & Return to Login
              </button>
            </div>
          </div>
        </div>
      );
    }

    // If no error, render children normally
    return this.props.children;
  }
}

export default ErrorBoundary; 